export default __webpack_public_path__ + "static/media/ra-urban-disconected-c.e113fdfe.svg";